import { HasDependencies, hashString } from '../../api/types';
import { Domains } from '../../constants';
import { DataFields } from '../../types';
import { BaseAuthedTracker } from './baseTracker';

const DASHBOARD_DOWNLOADED_EVENT = '[Dashboard] Downloaded';
const DASHBOARD_DATA_VIEW_EXPORT_EVENT = '[Dashboard] Data View Exported';
const FULL_SCREEN_EVENT = '[Dashboard] Full Screen';
const SORT_COLUMNS_EVENT = '[Dashboard] Sort Data View Columns';
const SORT_BY_EVENT = '[Dashboard] Sort By Column Data View';
const CHOOSE_COLUMNS_EVENT = '[Dashboard] Choose Data View Columns';

export class DashboardTracker implements HasDependencies {
  constructor(
    readonly tracker: BaseAuthedTracker,
    readonly domain: Domains
  ) {}

  public getDeps = () => [hashString([...this.tracker.getDeps(), this.domain])];

  public trackDashboardDownload = (type: 'pdf' | 'png') => {
    this.tracker.track(DASHBOARD_DOWNLOADED_EVENT, this.domain, {
      type,
    });
  };

  public trackFullScreen = () => {
    this.tracker.track(FULL_SCREEN_EVENT, this.domain);
  };

  public trackDashboardDataViewExport = (type: 'csv' | 'xlsx') => {
    this.tracker.track(DASHBOARD_DATA_VIEW_EXPORT_EVENT, this.domain, {
      type,
    });
  };

  public trackColumnsSort = () => {
    this.tracker.track(SORT_COLUMNS_EVENT, this.domain);
  };

  public trackDataViewSortBy = (sortBy: DataFields) => {
    this.tracker.track(SORT_BY_EVENT, this.domain, { sortBy });
  };

  public trackChooseColumns = (columnSelector: 'old' | 'new') => {
    this.tracker.track(CHOOSE_COLUMNS_EVENT, this.domain);
  };
}
